import React, { createContext, useContext, useMemo } from "react";
import {
  AppAbility,
  DynamicAbilities,
  createAbilityForRole,
} from "@via/utils/ability";
import { useAuth } from "@via/hooks/useAuth";

interface AbilityContextType {
  getAbility: (dynamicAbilities: DynamicAbilities[]) => AppAbility;
}

const AbilityContext = createContext<AbilityContextType | undefined>(undefined);

export const AbilityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user } = useAuth();

  const getAbility = useMemo(
    () =>
      (dynamicAbilities: DynamicAbilities[] = []) =>
        createAbilityForRole(user?.userRole, dynamicAbilities),
    [user?.userRole]
  );

  return (
    <AbilityContext.Provider value={{ getAbility }}>
      {children}
    </AbilityContext.Provider>
  );
};

export const useAbility = (dynamicAbilities?: DynamicAbilities[]) => {
  const context = useContext(AbilityContext);
  if (!context) {
    throw new Error("useAbility must be used within an AbilityProvider");
  }
  return context.getAbility(dynamicAbilities || []);
};
